<template>
  <Stage>
    <FeatureImage
      v-if="image"
      :src="image"
      :imageCache="imageCache"
      :alt="`logo for ${headline} exam`"
    />
    <h1>{{ headline }}</h1>
    <p>{{ content }}</p>
    <Button
      v-if="buttonIsNavigation"
      :label="buttonText"
      :keys="[' ']"
      @click="$emit('next')"
    />
    <Button v-else disable-mouse :label="buttonText" />
  </Stage>
</template>
<script>
import { Button, Stage } from '@neurotrack/web-shared-components'
import essComponentProps from '@/mixins/essComponentProps'
import FeatureImage from '@/components/FeatureImage.vue'

export default {
  name: 'instructions_title_screen',
  components: { Button, Stage, FeatureImage },
  mixins: [essComponentProps],
  computed: {
    body() {
      return this.trialData?.body
    },
    footer() {
      return this.trialData?.footer
    },
    headline() {
      return this.body?.headline?.text
    },
    content() {
      return this.body?.content?.text
    },
    /**
     * @todo - handle all action types from:
     * https://github.com/neurotrack/ExamContracts/blob/master/commentary/2020-10-15%20-%20LayoutObjects.md
     *
     * Ideally, I guess, we should make a wrapper button that takes ESS data and
     * raises events.
     */
    buttonIsNavigation() {
      return this.footer?.button?.action === 'next'
    },
    buttonText() {
      return this.footer?.button?.text || 'Next'
    },
    image() {
      return this.body?.image?.filename
    }
  }
}
</script>

<style scoped>
img {
  width: 300px;
  height: 300px;
}
p {
  text-align: center;
}
</style>
